// 记住密码存local的key
export const RememberKey = '_RMK_'
